import { optimize } from 'ml-spectra-fitting';
export function joinBroadPeaks(peakList, options = {}) {
    let { shape = { kind: 'gaussian' }, optimization = { kind: 'lm', timeout: 10 }, } = options;
    let { width = 0.25 } = options;
    let broadLines = [];
    // Optimize the possible broad lines
    let max = 0;
    let maxI = 0;
    let count = 1;
    const peaks = JSON.parse(JSON.stringify(peakList));
    for (let i = peaks.length - 1; i >= 0; i--) {
        if (peaks[i].shape.soft) {
            broadLines.push(peaks.splice(i, 1)[0]);
        }
    }
    // Push a feke peak
    broadLines.push({ x: Number.MAX_VALUE, shape: { width: 0 }, y: 0 });
    let candidates = {
        x: [broadLines[0].x],
        y: [broadLines[0].y],
    };
    let indexes = [0];
    for (let i = 1; i < broadLines.length; i++) {
        if (Math.abs(broadLines[i - 1].x - broadLines[i].x) < width) {
            candidates.x.push(broadLines[i].x);
            candidates.y.push(broadLines[i].y);
            if (broadLines[i].y > max) {
                max = broadLines[i].y;
                maxI = i;
            }
            indexes.push(i);
            count++;
        }
        else {
            if (count > 2) {
                let optimizeShape = {
                    width: Math.abs(candidates.x[0] - candidates.x[candidates.x.length - 1]),
                };
                let fitted = optimize(candidates, [
                    {
                        x: broadLines[maxI].x,
                        y: max,
                        shape: optimizeShape,
                    },
                ], { shape, optimization });
                let { peaks: peak } = fitted;
                peak[0].index = Math.floor(indexes.reduce((a, b) => a + b, 0) / indexes.length);
                peak[0].shape.soft = false;
                peaks.push(peak[0]);
            }
            // Put back the candidates to the signals list
            else {
                indexes.forEach((index) => {
                    peaks.push(broadLines[index]);
                });
            }
            candidates = { x: [broadLines[i].x], y: [broadLines[i].y] };
            indexes = [i];
            max = broadLines[i].y;
            maxI = i;
            count = 1;
        }
    }
    peaks.sort((a, b) => {
        return a.x - b.x;
    });
    return peaks;
}
//# sourceMappingURL=joinBroadPeaks.js.map